import { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AnnouncementBanner } from './AnnouncementBanner';
import { fetchPublishedAnnouncements } from '../../ReduxStore/Announcements/AnnouncementsOperations';
import { getPublishedAnnouncements } from '../../ReduxStore/Announcements/AnnouncementsSelectors';
import { Dispatch } from '../../ReduxStore/types';

export function AnnouncementBannerContainer(): ReactElement | null {
  const dispatch = useDispatch<Dispatch>();
  const announcements = useSelector(getPublishedAnnouncements);

  useEffect(() => {
    void dispatch(fetchPublishedAnnouncements());
  }, [dispatch]);

  if (announcements.length === 0) {
    return null;
  }

  return <AnnouncementBanner announcements={announcements} />;
}
